import { ErrorHandler, Injectable } from '@angular/core';
import { GrpcError } from '../shared-models/GrpcError';
import { LoaderService } from './loader.service';
import { LoaderKeys } from '../constants/constants';
import * as Sentry from '@sentry/angular';
import { getCurrentEnvironment } from '../helpers/helper';
import { CommonService } from './common.service';
import { SnackbarService } from './snackbar.service';
import { SnackBarConfig, snackBarType } from '../constants/enum';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    public loaderService: LoaderService,
    private commonService: CommonService,
    public snackbarService: SnackbarService,
  ) { }

  handleError(error: any): void {
    if (error.toString().toLowerCase().includes('uncaught (in promise)')) {
      return;
    }

    //console.log('status in global error handler before handling : ' + this.loaderService.isLoading(error.loaderKey));
    if (error instanceof GrpcError) {
      if (error.loaderKey != undefined) this.loaderService.stopLoading(error.loaderKey);
    }
    else {
      // turned of capture exception for now due to overload front end exceptions. have to turn on when backend is stable
      if (environment.sentryConfig.isEnableLogging === 'true')
        this.captureException(error);
    }

    // 
    // this.snackbarService.openSnackBar(
    //   error?.message,
    //   snackBarType.Error,
    //   SnackBarConfig.Timer,
    //   SnackBarConfig.VerticalPosition,
    //   SnackBarConfig.HorizontalPostion,
    //   false,
    //   true,
    //   SnackBarConfig.XCircleIcon,
    // );
    //Sentry.captureException(error.originalError || error);
    console.error('Global error handler:', error);
  }

  captureException(error: Error, data: any = null) {
    Sentry.withScope((scope: any) => {
      scope.setTag('UserEmail', this.commonService.userEmail);
      scope.setTag('BusinessName', this.commonService.businessName);
      scope.setTag('IsFrontend', 'true');
      if (data !== null) scope.setExtra('Details', data);
      Sentry.captureException(error);
    });
  }
}
